import clsx from "clsx";
import { PortalDialogProps } from "@app/services/modal.service";
import { useT } from "@app/contexts/preferences.context";
import Modal from "../modal/modal.component";
import { IcAlert, IcCircleCheck, IcX } from "../icons";
import { btn, btnGhost, btnPrimary, iconBtn } from "../ui";

export interface BootResultModalData {
  success: boolean;
  message: string;
  /** Tên máy (nếu biết) */
  name?: string;
}

/**
 * Popup kết quả boot (thay cho toast). Đóng với { see: true } khi bấm "Xem máy".
 */
function BootResultModal({ portalDialogRef, portalData }: PortalDialogProps<BootResultModalData>) {
  const t = useT();
  const success = !!portalData?.success;

  return (
    <Modal onCancel={portalDialogRef.close} buttonCancelInChildren={false}>
      <div className="relative flex w-[min(420px,calc(100vw-32px))] flex-col items-center gap-2 px-6 pb-6 pt-8 text-center text-fg">
        <button
          type="button"
          className={clsx(iconBtn, "!absolute right-3 top-3 !h-8 !w-8")}
          aria-label={t("Đóng")}
          onClick={() => portalDialogRef.close()}
        >
          <IcX className="h-4 w-4" />
        </button>
        <span
          className={clsx(
            "mb-1 grid h-14 w-14 place-items-center rounded-2xl",
            success ? "bg-ok-soft text-ok" : "bg-bad-soft text-bad"
          )}
        >
          {success ? <IcCircleCheck className="h-7 w-7" /> : <IcAlert className="h-7 w-7" />}
        </span>
        <h2 className="text-lg font-bold">{success ? t("Tạo máy thành công") : t("Tạo máy thất bại")}</h2>
        {portalData?.name && <p className="m-0 font-semibold">{portalData.name}</p>}
        <p className="m-0 max-w-[40ch] text-[13.5px] text-muted">{portalData?.message}</p>
        {!success && (
          <p className="m-0 max-w-[40ch] text-[12.5px] text-faint">
            {t("Máy đã được gỡ khỏi danh sách và tiền thuê đã được hoàn lại vào số dư.")}
          </p>
        )}
        <div className="mt-3 flex w-full gap-2">
          <button type="button" className={clsx(btn, btnGhost, "flex-1")} onClick={() => portalDialogRef.close()}>
            {t("Đóng")}
          </button>
          {success && (
            <button type="button" className={clsx(btn, btnPrimary, "flex-1")} onClick={() => portalDialogRef.close({ see: true })}>
              {t("Xem máy")}
            </button>
          )}
        </div>
      </div>
    </Modal>
  );
}

export default BootResultModal;
